import { PoolModelApi } from 'api-typings/users/users';
import { PoolModel } from './pools.model';

export function transformPool(pool: PoolModelApi): PoolModel {
  return {
    id: pool.id,
    name: pool.name,
    displayName: pool.display_name,
    isTalentNetwork: pool.is_talent_network,
    isTestPool: pool.is_test_pool,
  };
}
